<template>
  <ClientsTable :clients="clientsData" :layout="'list'"></ClientsTable>
</template>

<script type="text/javascript">
  import ClientsTable from "../ClientsTable/ClientsTable";
  import { mapState, mapActions } from "vuex";
  import eventBus from "../../../../event-bus/eventBus";

  export default {
    name: "List",
    components: {ClientsTable},
    methods: {
      ...mapActions("getClients", ["getClients", "getHeadersTable"])
    },
    data() {
      return {
        clientsData: []
      }
    },
    mounted() {
      this.updateLanguage(this.getCurrentLanguage);
      const language = this.getCurrentLanguage;
      this.getHeadersTable({creds: {language}});
      eventBus.$on("getClientsSuccess", (clients) => {
        this.clientsData = clients;
      });
      eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeadersTable({creds: {language}});
      });
    },
    computed: {
      ...mapState("getClients", {
        dataReceive: state => state.dataReceive
      })
    },
    beforeDestroy() {
      eventBus.$off('getClientsSuccess');
      eventBus.$off('changeLanguage');
    }
  }
</script>

<style src="./List.scss" lang="scss"></style>